const topCncpt = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let to = gsap.to('#jsSecMain .js-main-wrap .js-cover-box', {
      opacity: 1,
      ease: "none",
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: '#jsSecCncpt',
        start: '0% 100%',
        end: '0% 0%',
        scrub: 0,
        // markers: true
      }
    })

    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        to.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
})()
export default topCncpt;